//Timespan constants
export const MONTH = 'month';
export const DAY = 'day';
export const WEEK = 'week';
export const YEAR = 'year';
